import { render } from "./EditSpent.vue?vue&type=template&id=170b1c84&ts=true"
import script from "./EditSpent.vue?vue&type=script&lang=ts"
export * from "./EditSpent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__